import { PdfHelper } from "../helpers/pdfhelper";
import { PDFDocument } from "pdf-lib";
import { isCapacitorNative, savePdfBlobOnNative } from "../helpers/nativePdf";

const pdfMake = require('pdfmake'); // PDF generation module
var pdfFonts = require('pdfmake/build/vfs_fonts');
pdfMake.vfs = pdfFonts.pdfMake.vfs;

interface InvoiceData {
    'tt-InvHead': Array<{
        'tt-InvLine': Array<{
            ordline: string;
            qual: string;
            des: string;
            lncusref: string;
            qty: number;
            uom: string;
            uprice: number;
            disc: string | number;
            lval: number;
            notes?: string;
            ordnum?: string;
        }>;
        brn: string;
        cologo: string[];
        coname: string;
        cotel: string;
        acode: string;
        bsortno: string;
        baccno: string;
        baname: string;
        bname: string;
        invnum: string;
        ordnum: string;
        invdatedesc: string;
        cusref: string;
        covat?: string;
        terms: string;
        'terms-Line1'?: string;
        'terms-Line2'?: string;
        'terms-Line3'?: string;
        'terms-Line4'?: string;
        footer1: string;
        footer2: string;
        currency: string;
        nval: number;
        vval: number;
        gval: number;
        paid: number;
        balance: number;
        name: string;
        address1: string;
        address2: string;
        city: string;
        county: string;
        country: string;
        pcode: string;
        dname: string;
        daddress1: string;
        daddress2: string;
        dxity: string;
        dcounty: string;
        dcountry: string;
        dpcode: string;
    }>;
    acode: string;
}

export interface InvoiceGenerateOptions {
    /** When true, always trigger a file download (skip window.open). */
    forceDownload?: boolean;
    /** Override default filename. */
    fileName?: string;
    /** Native only: write the file without opening the share sheet (bulk download collects URIs first). */
    deferShare?: boolean;
}

export class InvoiceDefinition {
    // Define class properties with types
    private mainFont: number = 10;
    private tableFont: number = 8;
    private tableFontSize: number = 9;
    private primaryColour: string = '#2B2B2B';
    private secondaryColour: string = '';
    private mainColour: string = '#898989';
    private darkColour: string = '#747474';
    private black: string = '#333333';
    private renderConfig: any = null;
    private startTime: Date | null = null;
    private pageBreaks: number[] = [];
    private theType: string = '';
    private finalName: string = '';
    private helper: PdfHelper = new PdfHelper();
    private inName: string = '';
    private totalPages: number = 0;
    private generateOptions: InvoiceGenerateOptions = {};

    // Method to generate pricelist
    async generate(
        url: string,
        dataset: InvoiceData,
        inName: string,
        options?: InvoiceGenerateOptions
    ): Promise<string | undefined> {

        this.inName = inName;
        this.generateOptions = options || {};


        pdfMake.fonts = {
            Roboto: {
                normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
                bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
                italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
                bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
            },

        };


        // Initialize variables
        let theTable: any = [];
        let typeName = '';
        let z = 0;

        let tHead = dataset['tt-InvHead'][0];
        let tBody = dataset['tt-InvHead'][0]['tt-InvLine'];

        // Extract type from dataset
        // Set primary and secondary colors based on company
        this.primaryColour = this.helper.getPrimaryColour(tHead['brn']);
        this.secondaryColour = this.helper.getSecondaryColour(tHead['brn']);


        let logo = tHead['cologo'];

        console.log(logo[logo.length - 1]);
        console.log(tHead['brn']);

        let img = await this.helper.resolveLogoByBrand(tHead['brn']);


        const headerLeft = this.generateHeaderLeft(tHead);
        const headerRight = await this.generateHeaderRight(tHead, img as any);
        const addressLeft = this.generateAddressLeft(tHead);


        const footerTerms = this.generateFooterTerms(tHead);

        const footerLeft = this.generateFooterLeft(tHead, footerTerms);
        const footerRight = this.generateFooterRight(tHead);
        const copyright = this.generateCopyright(tHead);



        const productTable = this.generateProductTable(tBody);

        let self = this;
        // Return promise for PDF generation
        return new Promise((resolve: any, reject: any) => {
            // Create PDF printer instance

            let customer = dataset.acode;


            let counter = 0;


            // Define header function with proper this context
            var headerFunction = (function (this: InvoiceDefinition, currentPage: number, pageCount: number) {
                return {
                    margin: 8,
                    stack: [
                        {
                            columns: [
                                {
                                    stack: headerLeft,
                                    margin: [0, 0, 5, 0]
                                },
                                {
                                    stack: headerRight,
                                    margin: [5, 0, 10, 0]
                                },
                            ],
                            margin: [10, 5, 10, 0]
                        },
                        {
                            columns: [
                                {
                                    table: {
                                        widths: ['*'],
                                        body: [
                                            [
                                                {
                                                    stack: addressLeft,
                                                    height: 530 // Sets a specific height for the cell

                                                }
                                            ]
                                        ]
                                    },
                                    layout: {
                                        hLineWidth: function (i: number, node: any) {
                                            return 1; // 1px horizontal border
                                        },
                                        vLineWidth: function (i: number, node: any) {
                                            return 1; // 1px vertical border
                                        },
                                        hLineColor: function (i: number, node: any) {
                                            return '#000000'; // Black border color
                                        },
                                        vLineColor: function (i: number, node: any) {
                                            return '#000000'; // Black border color
                                        }
                                    },
                                    margin: [0, 0, 5, 0]
                                },
                                {
                                    stack: this.generateAddressRight(tHead, currentPage),
                                    margin: [5, 0, 10, 0]
                                }
                            ],
                            margin: [10, 0, 5, 0]
                        }
                    ]
                };
            }).bind(this);





            let footerCopy = {
                text: copyright,
                fontSize: 8,
                alignment: 'center',
                margin: [0, 10, 0, 0],
                color: this.mainColour
            };





            var myTableLayouts = {
                borderedTable: {
                    hLineWidth: function (i: number, node: any) {
                        if (i === 0 || i === node.table.body.length) {
                            return 0;
                        }
                        return (i === node.table.headerRows) ? 1 : 0;
                    },
                    vLineWidth: function (i: number, node: any) {
                        if (counter > 1) {
                            return 0;
                        };
                        return (i === 0 || i === node.table.widths.length) ? 0 : 1;
                    },
                    hLineColor: function (i: number) {
                        return i === 1 ? '#F0F0F0' : '#F0F0F0';
                    },
                    vLineColor: function (i: number) {
                        return '#F0F0F0';
                    },
                    paddingTop: function (i: number, node: any) {
                        return 5;
                    },
                    paddingBottom: function (i: number, node: any) {
                        return 5;
                    },
                    paddingLeft: function (i: number) {
                        return i === 0 ? 5 : 3;
                    },
                    paddingRight: function (i: number, node: any) {
                        return (i === node.table.widths.length - 1) ? 5 : 3;
                    },
                    fillColor: function (i: number, node: any) {
                        return '#FFFFFF'
                    }
                },
                exampleLayout: {
                    hLineWidth: function (i: number, node: any) {
                        if (i === 0 || i === node.table.body.length) {
                            return 0;
                        }
                        return (i === node.table.headerRows) ? 1 : 0;
                    },
                    vLineWidth: function (i: number, node: any) {
                        if (counter > 1) {
                            return 0;
                        };
                        return (i === 0 || i === node.table.widths.length) ? 0 : 1;
                    },
                    hLineColor: function (i: number) {
                        return i === 1 ? '#F0F0F0' : '#F0F0F0';
                    },
                    vLineColor: function (i: number) {
                        return '#F0F0F0';
                    },
                    paddingTop: function (i: number, node: any) {
                        return 5;
                    },
                    paddingBottom: function (i: number, node: any) {
                        return 5;
                    },
                    paddingLeft: function (i: number) {
                        return i === 0 ? 4 : 8;
                    },
                    paddingRight: function (i: number, node: any) {
                        return (i === node.table.widths.length - 1) ? 4 : 8;
                    },
                    fillColor: function (i: number, node: any) {
                        return (i % 2 === 0) ? '#ffffff' : '#F9F9F9';
                    }
                },
                outlinedTable: {
                    hLineWidth: function (i: number, node: any) {
                        if (i === 0 || i === node.table.body.length) {
                            return 1;
                        }
                        return (i === node.table.headerRows) ? 1 : 1;
                    },
                    vLineWidth: function (i: number, node: any) {
                        if (counter > 1) {
                            return 1;
                        };
                        return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                    },
                    hLineColor: function (i: number) {
                        return i === 1 ? '#333333' : '#333333';
                    },
                    vLineColor: function (i: number) {
                        return '#333333';
                    },
                    paddingTop: function (i: number, node: any) {
                        return 5;
                    },
                    paddingBottom: function (i: number, node: any) {
                        return 5;
                    },
                    paddingLeft: function (i: number) {
                        return i === 0 ? 4 : 8;
                    },
                    paddingRight: function (i: number, node: any) {
                        return (i === node.table.widths.length - 1) ? 4 : 8;
                    },
                    fillColor: function (i: number, node: any) {
                        return (i % 2 === 0) ? '#FFFFFF' : '#FFFFFF';
                    }
                },
                linedTable: {
                    hLineWidth: function (i: number, node: any) {
                        return 1;
                    },
                    vLineWidth: function (i: number, node: any) {

                        return 1;
                    },
                    hLineColor: function (i: number) {
                        return i === 1 ? '#333333' : '#333333';
                    },
                    vLineColor: function (i: number) {
                        return '#333333';
                    },
                    paddingTop: function (i: number, node: any) {
                        return 5;
                    },
                    paddingBottom: function (i: number, node: any) {
                        return 5;
                    },
                    paddingLeft: function (i: number) {
                        return i === 0 ? 4 : 8;
                    },
                    paddingRight: function (i: number, node: any) {
                        return (i === node.table.widths.length - 1) ? 4 : 8;
                    },
                    fillColor: function (i: number, node: any) {
                        return (i % 2 === 0) ? '#FFFFFF' : '#FFFFFF';
                    }
                },
                trimmedLinedTable: {
                    hLineWidth: function (i: number, node: any) {
                        return 1;
                    },
                    vLineWidth: function (i: number, node: any) {

                        return 1;
                    },
                    hLineColor: function (i: number) {
                        return i === 1 ? '#333333' : '#333333';
                    },
                    vLineColor: function (i: number) {
                        return '#333333';
                    },
                    paddingTop: function (i: number, node: any) {
                        return 3;
                    },
                    paddingBottom: function (i: number, node: any) {
                        return 1;
                    },
                    paddingLeft: function (i: number) {
                        return i === 0 ? 4 : 8;
                    },
                    paddingRight: function (i: number, node: any) {
                        return (i === node.table.widths.length - 1) ? 4 : 8;
                    },
                    fillColor: function (i: number, node: any) {
                        return (i % 2 === 0) ? '#FFFFFF' : '#FFFFFF';
                    }
                },
                linedTableSlim: {
                    hLineWidth: function (i: number, node: any) {
                        return 1;
                    },
                    vLineWidth: function (i: number, node: any) {

                        return 1;
                    },
                    hLineColor: function (i: number) {
                        return i === 1 ? '#333333' : '#333333';
                    },
                    vLineColor: function (i: number) {
                        return '#333333';
                    },
                    paddingTop: function (i: number, node: any) {
                        return 2;
                    },
                    paddingBottom: function (i: number, node: any) {
                        return 2;
                    },
                    paddingLeft: function (i: number) {
                        return i === 0 ? 2 : 2;
                    },
                    paddingRight: function (i: number, node: any) {
                        return (i === node.table.widths.length - 1) ? 3 : 3;
                    },
                    fillColor: function (i: number, node: any) {
                        return (i % 2 === 0) ? '#FFFFFF' : '#FFFFFF';
                    }
                },
                blankLineTable: {
                    hLineWidth: function (i: number, node: any) {
                        return 0;
                    },
                    vLineWidth: function (i: number, node: any) {
                        return 0;
                    },
                    hLineColor: function (i: number) {
                        return i === 1 ? '#F0F0F0' : '#F0F0F0';
                    },
                    vLineColor: function (i: number) {
                        return '#F0F0F0';
                    },
                    paddingTop: function (i: number, node: any) {
                        return 0;
                    },
                    paddingBottom: function (i: number, node: any) {
                        return 0;
                    },
                    paddingLeft: function (i: number) {
                        return 0;
                    },
                    paddingRight: function (i: number, node: any) {
                        return 0;
                    }
                },
                subTable: {
                    hLineWidth: function (i: number, node: any) {
                        return 0;
                    },
                    vLineWidth: function (i: number, node: any) {
                        return 0;
                    },
                    hLineColor: function (i: number) {
                        return i === 1 ? '#ffffff' : '#ffffff';
                    },
                    vLineColor: function (i: number) {
                        return '#ffffff';
                    },
                    paddingTop: function (i: number, node: any) {
                        return 0;
                    },
                    paddingBottom: function (i: number, node: any) {
                        return 0;
                    },
                    paddingLeft: function (i: number) {
                        return 0;
                    },
                    paddingRight: function (i: number, node: any) {
                        return 0;
                    }
                }
            };


            let blankLine = {
                width: '100%',
                layout: 'blankLineTable', // optional
                table: {
                    widths: ['*'],
                    headerRows: 0,
                    body: [
                        [
                            {
                                text: ' ',
                                fillColor: this.primaryColour,
                            },
                        ]
                    ]
                }
            };

            theTable.push({
                margin: [0, 15, 0, 0],
                width: '100%',
                layout: 'exampleLayout', // optional
                table: {
                    headerRows: 1,
                    body: productTable,
                    widths: [15, '*', 50, 50, 50, 50, 50]
                }
            });

            /*
            theTable.push({
                width: '100%',
                layout: 'blankLineTable', // optional
                table: {
                    headerRows: 1,
                    body: [
                        [
                            {
                                text: ' ',
                            },
                            { text: "NOTES: \nnone", color: this.darkColour }
                        ]
                    ],
                    widths: [20, '*']
                },
                margin: [0, 10, 0, 30]
            });
            */

            theTable.push({
                text: '  ',
            });


            var docDefinition = {
                pageMargins: [20, 260, 20, 140],
                footer: function (currentPage: any, totalPages: any) {
                    console.log(currentPage);
                    return {
                        text: currentPage === 1 ? '' : '',
                        margin: currentPage < totalPages ? [0, 0, 0, 0] : [20, 100, 20, 0] // More space on page 1
                    };
                },
                header: headerFunction,
                content: theTable,
                styles: {
                    header: {
                        fontSize: 9,
                        bold: true,
                        alignment: 'right',
                        margin: [0, 190, 0, 80]
                    },
                    subheader: {
                        fontSize: 9
                    },
                    superMargin: {
                        margin: [20, 0, 40, 0],
                        fontSize: 15
                    },
                    cellWithPadding: {
                        margin: [20, 0, 0, 0]
                    }
                },
                defaultStyle: {
                    font: 'Roboto'
                },
                layouts: myTableLayouts
            };


            pdfMake.tableLayouts = myTableLayouts;


            let chunks = [];

            let dd = { ...docDefinition } as any;
            dd.background = function (currentPage: number, pageSize: any) {
                if (currentPage < self.totalPages) {
                    let footerCop = { ...footerCopy };
                    let f = {
                        absolutePosition: { x: 0, y: 785 }, // Adjust Y to the bottom
                        margin: [0, 10, 0, 10],
                        width: '100%',
                        stack: [
                            blankLine,
                            footerCop
                        ]
                    };

                    return [f];
                }
                return [
                    {
                        absolutePosition: { x: 0, y: 620 }, // Adjust Y to the bottom
                        margin: [0, 50, 3, 0],
                        stack: [
                            {
                                columns: [
                                    {
                                        stack: footerLeft,
                                        margin: [5, 0, 5, 0]
                                    },
                                    {
                                        stack: footerRight,
                                        margin: [5, 0, 10, 0]
                                    }
                                ],
                                margin: [10, 0, 5, 10]
                            },
                            blankLine,
                            {
                                columns: [
                                    copyright
                                ]
                            },
                        ]
                    }
                ];
            }.bind(this);



            pdfMake.createPdf(docDefinition).getBuffer(async (buffer: any) => {
                const pdfData = new Uint8Array(buffer); // Convert to Uint8Array for pdf.js

                try {
                    const pdfData = new Uint8Array(buffer); // Convert to Uint8Array
                    const pdfDoc = await PDFDocument.load(pdfData); // Load into pdf-lib
                    self.totalPages = pdfDoc.getPageCount();

                    //We need to updte the doc definition with the new total pages

                    // Create a fresh copy of the document definition with the image data
                    let dd = { ...docDefinition } as any;
                    dd.background = function (currentPage: number, pageSize: any) {
                        if (currentPage < self.totalPages) {
                            let footerCop = { ...footerCopy };
                            let f = {
                                absolutePosition: { x: 0, y: 785 }, // Adjust Y to the bottom
                                margin: [0, 10, 0, 10],
                                width: '100%',
                                stack: [
                                    blankLine,
                                    footerCop
                                ]
                            };

                            return [f];
                        }
                        return [
                            {
                                absolutePosition: { x: 0, y: 620 }, // Adjust Y to the bottom
                                margin: [0, 50, 3, 0],
                                stack: [
                                    {
                                        columns: [
                                            {
                                                stack: footerLeft,
                                                margin: [5, 0, 5, 0]
                                            },
                                            {
                                                stack: footerRight,
                                                margin: [5, 0, 10, 0]
                                            }
                                        ],
                                        margin: [10, 0, 5, 10]
                                    },
                                    blankLine,
                                    {
                                        columns: [
                                            copyright
                                        ]
                                    },
                                ]
                            }
                        ];
                    }.bind(this);

                    const opts = self.generateOptions || {};
                    const fileName =
                        opts.fileName ||
                        (opts.forceDownload
                            ? `invoice-${self.inName || 'download'}.pdf`
                            : 'invoice.pdf');
                    const nativeUri = await self.generateFinalPDF(dd, opts, fileName);
                    resolve(nativeUri);
                } catch (error) {
                    console.error('Error generating PDF:', error);
                    reject(error);
                }
            });


        });
    }

    getTable(data: any, renderConfig: any, clearLine: any) {

        //clearLine
        return [];

    }


    renderRow(renderConfig: any, data: any, itm: any, indent: boolean = false) {
        return [];
    }




    doReplace = (actionData: any, data: any) => {
        if (actionData == null || actionData.length == 0) {
            return '';
        }
        return actionData.split(data[0]).join(data[1]);

    };
    doFormatCurrency = (actionData: any, data: any) => {
        return actionData;
    };





    async generateFinalPDF(docDefinition: any, args: any, fileName: string): Promise<string | undefined> {

        console.log(JSON.stringify(docDefinition));
        const forceDownload = !!(args && args.forceDownload);
        const deferShare = !!(args && args.deferShare);
        const pdf = pdfMake.createPdf(docDefinition);

        if (await isCapacitorNative()) {
            const blob = await new Promise<Blob>((resolve, reject) => {
                try {
                    pdf.getBlob((b: Blob) => resolve(b));
                } catch (e) {
                    reject(e);
                }
            });
            const uri = await savePdfBlobOnNative(blob, fileName, { deferShare });
            if (!uri) {
                throw new Error('Failed to save invoice PDF on device');
            }
            console.log('PDF written on native device', uri);
            return uri;
        }

        // Bulk: use pdfMake's native download so the browser always saves (never opens a tab)
        if (forceDownload) {
            return new Promise((resolve) => {
                pdf.download(fileName, () => {
                    console.log('PDF download started (forceDownload)');
                    resolve(undefined);
                });
            });
        }

        return new Promise((resolve) => {
            pdf.getBlob((blob: any) => {
                const url = URL.createObjectURL(blob);

                const triggerDownload = () => {
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = fileName;
                    link.style.display = 'none';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                };

                // Try to open in new window first (works in most browsers)
                const newWindow = window.open(url, '_blank');

                // Safari and some browsers may block popup, so provide download fallback
                if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
                    triggerDownload();
                    console.log('PDF download started - popup was blocked');
                } else {
                    console.log('PDF opened in new window');
                }

                setTimeout(() => {
                    URL.revokeObjectURL(url);
                }, 1000);

                resolve(undefined);
            });
        });

    }






    generateHeaderLeft(data: any) {
        return [
            {
                text: `${data.coname} ${data.cotel}`,
                alignment: 'left',
                margin: [0, 0, 0, 10],
                fontSize: 10,
                color: this.darkColour
            },
            {
                layout: 'outlinedTable', // optional,
                table: {
                    widths: ['*'],
                    layout: 'outlinedTable', // optional
                    body: [
                        // Table headers
                        [
                            {
                                verticalAlign: 'bottom',
                                columns: [
                                    {
                                        text: 'INVOICE',
                                        color: this.black,
                                        fontSize: 18,
                                        bold: true,
                                        width: 75,
                                        verticalAlign: 'bottom',
                                        margin: [0, 0, 0, 0]
                                    },
                                    {
                                        text: 'RE-PRINT',
                                        color: 'red',
                                        align: 'left', fontSize: 14,
                                        margin: [5, 4, 0, 0],
                                        verticalAlign: 'bottom'
                                    },
                                ]
                            }
                        ],
                    ]
                },
                alignment: 'left',
                margin: [0, 0, 0, 5],
            },
            {
                layout: 'outlinedTable', // optional,
                table: {
                    widths: ['*'],
                    body: [
                        // Table headers
                        [
                            {
                                columns: [
                                    {
                                        text: 'Customer Account No.',
                                        color: this.black,
                                        bold: true,
                                        margin: [0, 0, 0, 0]
                                    },
                                    {
                                        text: data.acode, bold: true, color: this.black, margin: [0, 0, 0, 0]
                                    },
                                ]
                            }
                        ],
                    ]
                },
                alignment: 'left',
                margin: [0, 0, 0, 5],
                fontSize: 11
            },
        ];
    }

    generateAddressLeft(data: any) {
        return [
            {
                layout: 'blankLineTable', // optional,
                table: {
                    widths: ['*'],
                    body: [
                        // Table headers
                        [
                            { text: this.getInvoiceAddress(data), bold: false, color: this.black, margin: [0, 5, 5, 41] },
                        ],
                    ],
                    height: 90
                },
                alignment: 'left',
                margin: [0, 0, 0, 0],
                fontSize: 10,
            },
        ];
    }

    generateAddressRight(data: any, pageIndex: number) {
        let lineMargin = [0, 0, 0, 4];

        return [
            {
                columns: [
                    { text: 'Page ' + pageIndex, bold: false, color: this.black, width: 90 },
                    /*  { text: 'Bank: ' + data.bsortno + '  ' + data.baccno, color: this.black }*/
                ],
                alignment: 'left', margin: [0, 0, 0, 5], fontSize: this.mainFont
            },
            {
                layout: 'trimmedLinedTable', // optional,
                fontSize: this.mainFont,
                table: {
                    widths: [80, 162],
                    body: [
                        // Table headers
                        [
                            { text: 'Invoice No', bold: true, color: this.black, width: 70, fontSize: this.mainFont, margin: lineMargin },
                            { text: data.invnum, color: this.black, fontSize: this.mainFont, margin: lineMargin }
                        ],
                        [
                            { text: 'Job No', bold: true, color: this.black, width: 70, margin: lineMargin },
                            { text: data.ordnum, color: this.black, margin: lineMargin },
                        ],
                        [
                            { text: 'Invoice Date', bold: true, color: this.black, width: 70, margin: lineMargin },
                            { text: this.helper.formatDate(data.invdatedesc), color: this.black, margin: lineMargin },
                        ],
                        [
                            { text: 'Reference', bold: true, color: this.black, width: 70, margin: lineMargin },
                            { text: data.cusref, color: this.black, margin: lineMargin },
                        ],
                        [
                            { text: 'Vat No.', bold: true, color: this.black, width: 70, margin: lineMargin },
                            { text: data?.covat, color: this.black, margin: lineMargin },
                        ],

                    ]
                }
            },
        ];
    }


    generateHeaderRight = async (data: any, img: string) => {


        let dim = await this.getBase64ImageDimensions(img);


        let availableDimensions = { x: 220, y: 72 };


        let optimalSize = this.getOptimalWidth(dim, availableDimensions);

        console.log({ image: img, alignment: 'center', width: optimalSize.width, margin: [0, 10, 10, 10], absolutePosition: { x: 300, y: 15 } });

        return [
            { image: img, alignment: 'center', width: optimalSize.width, margin: [0, 10, 10, 10], absolutePosition: { x: 300, y: 15 } },
        ];
    }
    /*
    generateHeaderRight(data: any, img: string) {
    
        return [
            { image: img, alignment: 'center', width: 140, margin: [0, 10, 10, 10] },
        ];
    }
        */


    generateFooterLeft(data: any, footerTerms: any) {
        return [
            {
                layout: 'outlineTable', // optional,

                table: {
                    widths: ['*'],
                    body: [
                        // Table headers
                        [{

                            margin: [0, 4, 4, 4],
                            columns: [
                                {
                                    text: 'Site Address',
                                    color: this.black,
                                    width: 70,
                                    bold: true,
                                },
                                {
                                    text: this.getCustomerAddress(data),
                                    color: this.black,
                                    align: 'left'
                                },
                            ]
                        }
                        ]
                    ]
                },
                alignment: 'left', margin: [0, 0, 0, 10], fontSize: this.mainFont
            },
            footerTerms,
            {
                columns: [
                    {
                        text: "Bank:",
                        width: 60, color: this.black
                    },
                    {
                        text: this.helper.rightTrim(data.baname, '.') + ' - ' + data.bname, color: this.black
                    }
                ],
                alignment: 'left', margin: [0, 3, 0, 0], fontSize: this.mainFont
            },
            {
                columns: [
                    {
                        text: "Sort Code:",
                        color: this.black,
                        width: 60,
                    },
                    {
                        text: data.bsortno + '   Account:' + data.baccno, color: this.black
                    }
                ],
                alignment: 'left', margin: [0, 3, 0, 0], fontSize: this.mainFont,
            },
        ]


    }

    getInvoiceAddress(dataset: any) {
        const keys = ["name", "address1", "address2", "city", "county", "country", "pcode"];
        const result = keys.filter(key => dataset[key] !== "").map(key => `${dataset[key]}`).join("\n");
        return result;
    }

    getCustomerAddress(dataset: any) {
        const keys = ["dname", "daddress1", "daddress2", "dxity", "dcounty", "dcountry", "dpcode"];
        const result = keys.filter(key => dataset[key] !== "" && dataset[key]).map(key => `${dataset[key]}`).join("\n");
        return result;
    }


    generateFooterRight(data: any) {

        const dataList = [
            { text: 'Net Amount', key: "nval" },
            { text: 'VAT Amount', key: "vval" },
            { text: 'Gross Amount', key: "gval" },
            { text: 'Paid To Date', key: "paid" },
            { text: 'Total Now Due', key: "balance" },
        ];

        let lines: any = [];
        dataList.forEach(x => {

            let val = data[x.key] ? data[x.key] : '';
            val = `${val}`.replace('£', '').trim();
            val = val == '' ? '0.00' : parseFloat(val).toFixed(2);

            let size = x.key == 'balance' ? 14 : this.mainFont;
            let color = x.key == 'balance' ? this.black : this.black;


            let currency = '';
            switch (data.currency) {
                case 'GBP':
                    currency = '£';
                    break;
                case 'USD':
                    currency = '$';
                    break;
                case 'EUR':
                    currency = '€';
                    break;
                case 'AUD':
                    currency = 'A$';
                    break;
                case 'CAD':
                    currency = 'C$';
                    break;
                case 'NZD':
                    currency = 'NZ$';
                    break;
                default:
                    currency = '£';
                    break;
            }

            lines.push([
                { text: x.text, bold: true, color: this.black, width: 120, fontSize: size, margin: [4, 4, 0, 4] },
                {
                    text: currency, color: color, fontSize: size, bold: true,
                    width: 30,
                    border: [true, true, false, true]
                },
                {
                    text: val, color: color, fontSize: size, bold: true,
                    alignment: 'right',

                }
            ]);
        });

        return [
            {
                layout: 'linedTableSlim', // optional
                table: {
                    widths: [140, 30, '*'],
                    body: lines
                },
            }
        ];
    }

    generateCopyright(data: any) {
        return [
            {
                text: data.footer1 + "\n" + data.footer2,
                color: this.darkColour, fontSize: 9, alignment: 'center', margin: [0, 10, 0, 0],
                bold: false
            }
        ]
    }


    generateProductTable(tBody: any) {
        let lh = [
            {
                text: 'Ln', fontSize: this.mainFont
            },
            {
                text: 'Description', fontSize: this.mainFont
            },
            {
                text: 'Lth/Qty', fontSize: this.mainFont
            },
            {
                text: 'Units', fontSize: this.mainFont
            },
            {
                text: 'Price', fontSize: this.mainFont
            },
            {
                text: 'Disc', fontSize: this.mainFont
            },
            {
                text: 'Total', fontSize: this.mainFont
            }
        ];

        if (!tBody || tBody.length == 0) {
            return [lh];
        }


        let rows: any = [];
        tBody.forEach((x: any) => {
            let row = [];
            let details = [];
            let keys = ['qual', 'des', 'lncusref'];

            const so = x['ordnum'] ? 'S/O ' + x['ordnum'] + "\n" : '';

            let perQty = x.uom == 'EA' ? '(each)' : '(per SQM)';


            let result = keys.filter(key => x[key] !== "").map(key => `${x[key]}`);

            if (x['notes']) {
                // result.push(`Notes: ${x['notes']}`);
            }

            const rString = result.join("\n");

            row.push({ text: x.ordline, fontSize: this.mainFont, color: this.darkColour });
            row.push({ text: so + rString, fontSize: this.mainFont, color: this.darkColour });
            row.push({ text: x.qty, fontSize: this.mainFont, color: this.darkColour });
            row.push({ text: x.uom, fontSize: this.mainFont, color: this.darkColour });
            row.push({ text: x.uprice.toFixed(2) + "\n" + perQty, fontSize: this.mainFont, color: this.darkColour });
            row.push({ text: x.disc && x.disc != '' ? parseFloat(`${x.disc}`).toFixed(2) : '', fontSize: this.mainFont, color: this.darkColour });
            row.push({ text: x.lval.toFixed(2), fontSize: this.mainFont, color: this.darkColour });
            rows.push(row);

        });


        return [
            lh,
            ...rows
        ];



    }

    generateFooterTerms(data: any) {

        let terms2 = '';
        let termsArr: any = [];
        let termsKeys = ['terms-Line1', 'terms-Line2', 'terms-Line3', 'terms-Line4'];

        termsKeys.forEach(x => {
            if (data.hasOwnProperty(x) && data[x] && data[x] != '') {
                termsArr.push(data[x]);
            }
        });

        terms2 = termsArr.join("\n");

        return {
            stack: [
                {

                    text: data.terms, alignment: 'left', margin: [0, 0, 0, 5], fontSize: 9, color: this.black
                },
                {
                    text: terms2, alignment: 'left', margin: [0, 0, 0, 5], fontSize: 9, color: this.black

                },
            ]
        };

    }



    formatDate(originalDate: string) {


        if (originalDate.indexOf('-') === -1) {
            return originalDate;
        }

        // Convert the string to a Date object
        const date = new Date(originalDate);

        // Format the date to "Day dd/mm/yyyy"
        const formattedDate = new Intl.DateTimeFormat('en-GB', {
            weekday: 'short',  // "Thur"
            day: '2-digit',    // "31"
            month: '2-digit',  // "10"
            year: 'numeric'    // "2024"
        }).format(date);
        return formattedDate;

    }



    getBase64ImageDimensions = async (base64String: string) => {


        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => resolve({ width: img.width, height: img.height });
            img.onerror = () => reject(new Error('Failed to load image'));
            img.src = base64String;
        });
    }

    isValidBase64Image(base64String: string) {
        const regex = /^data:image\/(png|jpeg|jpg|gif|webp);base64,/;
        return regex.test(base64String);
    }

    getOptimalWidth(metadata: any, availableDimensions: any) {
        let imageAspectRatio = metadata.width / metadata.height;
        let availableAspectRatio = availableDimensions.x / availableDimensions.y;

        let optimalWidth, optimalHeight;

        if (imageAspectRatio > availableAspectRatio) {
            // Scale by width
            optimalWidth = Math.min(metadata.width, availableDimensions.x);
            optimalHeight = optimalWidth / imageAspectRatio;
        } else {
            // Scale by height
            optimalHeight = Math.min(metadata.height, availableDimensions.y);
            optimalWidth = optimalHeight * imageAspectRatio;
        }

        return { width: optimalWidth, height: optimalHeight };
    }
}